import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Tab, { TabGroup as TabGroupLib } from '@amzn/meridian/tab';
import { useAppSelector } from 'src/store/store';
import { setSelectedTab } from 'src/store/adminConfigPageSlice/adminConfigPageSlice';
import { ADMIN_CONFIG_TABS, AdminConfigTabMap } from 'src/store/adminConfigPageSlice/common/constants';

/**
 * Default Component
 */
const TabGroup = () => {
  const { selectedTab } = useAppSelector((state) => state.adminConfigPage);
  const { selectedRegion } = useAppSelector((state) => state.regionTasksConfigPage);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <TabGroupLib
      value={selectedTab}
      onChange={(newTab) => {
        dispatch(setSelectedTab(newTab));
        navigate(AdminConfigTabMap.get(newTab), { replace: true });
      }}
    >
      <Tab value={ADMIN_CONFIG_TABS.Site}>Site Configuration</Tab>
      <Tab value={ADMIN_CONFIG_TABS.Task}>Task Configuration</Tab>
      <Tab value={ADMIN_CONFIG_TABS.Form}>Work/Requirement Form Configuration</Tab>
      <Tab value={ADMIN_CONFIG_TABS.Modification}>Task Modification Configuration</Tab>
      {selectedRegion.id > 0 && <Tab value={ADMIN_CONFIG_TABS.FormTaskConfig}>{selectedRegion.name} Edit</Tab>}
    </TabGroupLib>
  );
};

export default TabGroup;
